import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, ThemeProvider } from 'styled-components';
import { failure, gray45, spacer8 } from '@spotify-internal/encore-foundation';
import { typeStyleBody2 } from "../../styles";
var Help = styled.div.withConfig({
  displayName: "FormHelpText__Help",
  componentId: "tcmwq3-0"
})(["", ";margin-top:", ";", ";", ";", ";"], typeStyleBody2(), spacer8, function (props) {
  return props.error && css(["color:", ";"], failure);
}, function (props) {
  return !props.error && css(["color:", ";"], gray45);
}, function (props) {
  return props.maxChars && css(["font-feature-settings:'tnum';text-align:right;"]);
});
var propTypes = {
  error: PropTypes.bool,
  maxChars: PropTypes.number,
  theme: PropTypes.shape({
    formHelpText: PropTypes.oneOf(['dark'])
  })
};
var defaultProps = {
  theme: {}
};
export function FormHelpText(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Help, props));
}
FormHelpText.darkTheme = {
  formHelpText: 'dark'
};
FormHelpText.propTypes = propTypes;
FormHelpText.defaultProps = defaultProps;
export default FormHelpText;